import { Component, EventEmitter, OnInit, Input, Output, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ADPResourceService } from 'digital-core';
import { CountryCode } from 'libphonenumber-js';
import { Subscription } from 'rxjs';
import { AccountService } from 'src/app/core/services/account.service';
import { DeviceInventoryService } from 'src/app/core/services/device-inventory.service';
import { DeviceDto } from 'src/app/core/services/device-inventory/device.dto';
import { InventoryInfoDto } from 'src/app/core/services/device-inventory/inventory-info.dto';
import { LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { UtilityService } from 'src/app/core/services/utility.service';
import { dashboardRouteWithSlash } from 'src/app/route-constants';
import { ConfirmationDialogData } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog-data';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { PghUserDeviceBase } from 'src/app/shared/device/pgh-user-device';
import { SelectedDeviceService } from 'src/app/shared/device/selected-device.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { SnackbarService } from 'src/app/core/services/snackbar/snackbar.service';
@Component({
  selector: 'pgh-scan-qrcode',
  templateUrl: './scan-qrcode.component.html',
  styleUrls: ['./scan-qrcode.component.scss']
})
export class ScanQRCodeComponent implements OnInit {
  @Output() backEvent = new EventEmitter();
  @Input() invitationCode: string = '';
  @Input() invitationId: string = '';
  @Input() imeiOrSerialNum: string = '';
  @Input() isAdditionalDeviceFlow?:boolean=false;
  @Input() additionalDeviceTypeCode?:string='';

  countryIso: CountryCode = 'US';

  programCode: string;
  device: PghUserDeviceBase;
  hylaLink: string;
  private deviceInventoryInfo?: InventoryInfoDto;
  private diagnosticDevices?: DeviceDto[];

  public elementType:string;
  public value:string;
  public altLinkMessage:string;
  public correctionLevel:string;
  public isDesktopView:boolean = false;

  public isTablet:boolean = false;
  public isSmartwatch:boolean = false;

  private subscriptions: Subscription[] = [];

  constructor(
    public resourceService: ADPResourceService,
    private router: Router,
    private deviceInventoryService: DeviceInventoryService,
    private selectedDeviceService: SelectedDeviceService,
    private utilityServce: UtilityService,
    private accountService: AccountService,
    private loggedInUserSettings: LoggedInUserSettings,
    private dialog: MatDialog,
    private clipboard: Clipboard,
    private snackbarService: SnackbarService,
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isDesktopView = window.innerWidth >= 768;
  }

  ngOnInit(): void {

    let deviceTypeCode:string='';

    if(this.isAdditionalDeviceFlow){
      deviceTypeCode = this.additionalDeviceTypeCode;
    }else{
      this.device = this.selectedDeviceService.getSelectedDevice();
      deviceTypeCode = this.device?.deviceTypeCode;
    }

    if(deviceTypeCode === 'TABL'){
      this.isTablet = true;
    }else if(deviceTypeCode === 'SMAR'){
      this.isSmartwatch = true;
    }

    const imeiOrSerialBase64 = btoa(this.imeiOrSerialNum);

    const hylaUrl = deviceTypeCode === 'TABL'? this.resourceService.getPortalSetting("URL_Hyla_Tablet").Value :
                    deviceTypeCode === 'SMAR'? this.resourceService.getPortalSetting("URL_Hyla_Smartwatch").Value : '';

    this.hylaLink = hylaUrl.replace(/{{code}}/g, this.invitationCode);
    this.hylaLink = this.hylaLink.replace(/{{imeiBase64}}/g, imeiOrSerialBase64);

    this.elementType = 'url';
    this.correctionLevel = 'H';
    this.value = this.hylaLink;

    // TODO: Remove later, just keeping if there are decision shifts, but this is not being used anymore
    //const altText = this.resourceService.getPortalLabel("RegisterCellularDevice_QRCode_Link_Alt_Text").Value;
    //const linkText = "<a class='link' id='myButton' onclick='onAltTextClicked(event)' target='_blank' href='" + this.hylaLink + "'>Copy the URL</a>";
    //this.altLinkMessage = altText.replace(/{{here}}/g, linkText);

    this.isDesktopView = this.isUserUsingDesktop();
  }

  copyToClipboard(){
    this.clipboard.copy(this.hylaLink);
    this.snackbarService.showSimpleMessage(this.resourceService.getPortaLabelValue("RegisterCellularDevice_QRCode_Link_CopyClipboard"));
  }

  addAnotherDevice(): void{
    this.router.navigate(['additional-device-selection'],{ queryParams: { isOnboardingFlow: 'true'}});
  }

  goHome(): void {

    let dialogData: ConfirmationDialogData;

    dialogData = {
        title: "RegisterCellularDevice_AdditionalDevice_Questionnaire_Modal_Title",
        message: "RegisterCellularDevice_AdditionalDevice_Questionnaire_Modal_Message",
        cancelButtonText: "Global_Button_SkipForNow",
        confirmButtonText: "Global_Button_ContinueTest",
        contextData: { titleLeftAligned: false }
      };

    const confirmationDialog = this.dialog.open<ConfirmationDialogComponent, ConfirmationDialogData, boolean>(ConfirmationDialogComponent, {
      data: dialogData
    });
    this.subscriptions.push(confirmationDialog.afterClosed().subscribe({
      next: (result) => {
        if (result.toString() === 'false') {
          this.router.navigate([dashboardRouteWithSlash]);
        }
      }
    }));
  }

  isUserUsingDesktop() : boolean {

    // User agent string method
    let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    // Screen resolution method
    if (!isMobile) {
        let screenWidth = window.screen.width;
        let screenHeight = window.screen.height;
        isMobile = (screenWidth < 768 || screenHeight < 768);
    }

    // Touch events method
    if (!isMobile) {
        isMobile = (('ontouchstart' in window) || (navigator.maxTouchPoints > 0));
    }

    // CSS media queries method
    if (!isMobile) {
        let bodyElement = document.getElementsByTagName('body')[0];
        isMobile = window.getComputedStyle(bodyElement).getPropertyValue('content').indexOf('mobile') !== -1;
    }

    return !isMobile

}

}
